import React from "react"

class ChannelPresenter extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    
    return (
      <div className="ChannelPresenter">
        Channel Presenter
      </div>
    );
  }

};

export default ChannelPresenter